import { useState } from "react";

import { useForm } from "react-hook-form";

import { useAuth } from "../../../contexts/AuthContext";
import { TextInput } from "../../shared/Inputs/TextInput";
import Modal, { ModalProps } from "../../../layouts/Modal";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";

import useApiHelper from "../../../hooks/useApiHelper";

interface ShopifyAuthModalProps extends Omit <ModalProps, "children" | "width"> { }

type FormValues = {
  shop: string;
};

export default function ShopifyAuthModal({ open, setOpen }: ShopifyAuthModalProps) {
  const { post } = useApiHelper();
  const [error, setError] = useState<string | null>(null);
  const { register, handleSubmit, reset, formState: { errors } } = useForm<FormValues>();
  const { customerId, userId } = useAuth();
  const shopifyClientId = process.env.REACT_APP_SHOPIFY_CLIENT_ID;

  const onSubmit = async (data: FormValues) => {
    setOpen(false);

    const scopes =
    "write_products,write_orders,write_fulfillments,write_customers,write_locations,write_publications,write_inventory";
    const redirectUrl = process.env.REACT_APP_SHOPIFY_REDIRECT_URL;

    const state = `${customerId}|${userId}|${document.location.origin}/integrations/shopify`;

    const url =
      `https://${data.shop}/admin/oauth/authorize` +
      `?client_id=${shopifyClientId}` +
      `&scope=${encodeURIComponent(scopes)}` +
      `&redirect_uri=${encodeURIComponent(redirectUrl ?? "")}` +
      `&state=${encodeURIComponent(state)}`;
    // no `&grant_options[]=per-user`... makes it expire after 24 hours otherwise

    console.log("Opening Telleroo auth URL:", url);

    window.open(url, "_blank");

    reset();
  };

  // const bindWebhooks = () => {
  //   post<any, DefaultResponse>("/shopify/webhook/create", {}).then(
  //     (response) => {
  //       if (response.success) {
  //         console.log("Successfully set up Shopify webhooks");
  //       } else {
  //         console.error(
  //           "Failed to set up Shopify webhooks:",
  //           response.message
  //         );
  //       }
  //     }
  //   ).catch((error) => {
  //     console.error("Error setting up Shopify webhooks:", error);
  //   });
  // }

  return (
    <Modal open={open} setOpen={setOpen} width="max-w-2xl">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <TextInput
          label="Shop Domain"
          type="text"
          placeholder="shop-name.myshopify.com"
          registerName={"shop"}
          register={register}
        />
        {error && <p className="text-red-500">{error}</p>}
        {/* <ButtonInput isSubmit label="Authorise"    onClick={undefined}            classes={undefined} />
        <ButtonInput          label="Cancel"       onClick={() => setOpen(false)} classes={"ml-4 !bg-gray-600 hover:!bg-gray-700"} />
        <ButtonInput          label="Save & Close" onClick={bindWebhooks}         classes={"ml-4 !bg-green-600 hover:!bg-green-700"} /> */}
      </form>
    </Modal>
  );
}